/*-----------------------------------------------------------------
- Marketplace
-----------------------------------------------------------------*/

export default {
    title             : 'pazar yeri',
    'case-study-title': 'Quarkino ile Gerçek Başarı Hikayeleri',
};
